export const tourButtonStyles = () => ({
    tourMainButton: { position: 'fixed', bottom: 20, right: 20, zIndex: 9999 },
    badgeSetup: {
        '& .MuiBadge-badge': {
            zIndex: (theme) => theme.zIndex.modal,
        },
    },
    fabSetup: {
        boxShadow:
            '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
    },
    paperSetup: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        bottom: 70,
        right: 0,
        width: 400,
        maxHeight: 500,
        borderRadius: 2,
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        animation: 'slideUp 0.3s ease',
        '@keyframes slideUp': {
            from: { opacity: 0, transform: 'translateY(20px)' },
            to: { opacity: 1, transform: 'translateY(0)' },
        },
    },
    boxPaperSetup: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        py: 1.5,
        backgroundColor: '#0061DB',
        color: 'white',
    },
    footer: {
        p: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        textAlign: 'center',
        backgroundColor: (theme) =>
            theme.palette.mode === 'dark' ? '#121826' : theme.backgroundColor.primary,
    },
    title: { fontSize: '1rem', fontWeight: 500 },
    chipSetup: { fontSize: '0.7rem', height: 20 },
});

export const onBoardingTutorialModal = () => ({
    container: {
        textAlign: 'center',
        padding: '24px 16px',
    },
    title: {
        marginBottom: '16px',
        fontWeight: 700,
        fontSize: '1.5rem',
    },
    description: {
        marginBottom: '24px',
        lineHeight: 1.5,
    },
    icon: {
        fontSize: '80px',
        color: '#0061DB',
        marginBottom: '24px',
    },
    primaryButton: {
        backgroundColor: '#0061DB',
        color: '#FFFFFF',
        width: '150px',
        height: '48px',
        borderRadius: '6px',
        textTransform: 'none',
        fontWeight: 600,
        '&:hover': { backgroundColor: '#0050A3' },
    },
    secondaryButton: {
        backgroundColor: '#FFFFFF',
        color: '#0061DB',
        border: '2px solid #0061DB',
        width: '150px',
        height: '48px',
        borderRadius: '6px',
        textTransform: 'none',
        fontWeight: 600,
        marginRight: '16px',
        '&:hover': { backgroundColor: 'rgba(0,97,219,0.08)' },
    },

    buttonsBox: { display: 'flex', justifyContent: 'center' },
});
